import { NpoPlayerEvent } from '../../types/events';
import { addAccessibilityAttributes } from '../../ui/handlers/accessibilityhandler';
export function setupAccessibilityAttributes(playerContext) {
    const { player, npoplayer } = playerContext;
    const events = [NpoPlayerEvent.SourceLoaded, NpoPlayerEvent.AdBreakFinished, NpoPlayerEvent.AdError];
    const triggerAddAccessibilityAttributes = () => {
        for (const event of events) {
            player?.off(event, triggerAddAccessibilityAttributes);
        }
        if (npoplayer.streamOptions.enableSubtitles === true || npoplayer.userPreferences.subtitles_enabled === 'true') {
            player?.enableSubtitles();
        }
        addAccessibilityAttributes(npoplayer.container, npoplayer.streamObject.metadata);
    };
    for (const event of events) {
        player?.on(event, triggerAddAccessibilityAttributes);
    }
}
